import React, { useState, useEffect } from "react";

import Header from "./Header";
// import Pomodoro from "./Pomodoro";
import PomodoroScale from "./PomodoroScale";
import "./App.css";

export const SoundContext = React.createContext(true);

function App() {
  const [isSoundEnabled, setIsSoundEnabled] = useState(true);
  const soundStore = { get: isSoundEnabled, set: setIsSoundEnabled };

  return (
    <div className="App">
      <SoundContext.Provider value={soundStore}>
        <div className="header-wrapper">
          <Header />
        </div>
        <div className="pomodoro-wrapper">
          <PomodoroScale />
        </div>
      </SoundContext.Provider>
    </div>
  );
}

export default App;
